import { __assign, __rest } from "tslib";
import { useEffect } from 'react';
import { useToggle } from '../toggle';
export function useCheckbox(props, ref) {
    var _a = props.indeterminate, indeterminate = _a === void 0 ? false : _a, restProps = __rest(props, ["indeterminate"]);
    var toggle = useToggle(restProps, ref);
    // Use effect for apply state after component render.
    useEffect(function () {
        if (ref.current) {
            ref.current.indeterminate = indeterminate;
        }
    });
    return __assign(__assign({}, toggle), { inputProps: __assign(__assign({}, toggle.inputProps), { 'aria-checked': indeterminate ? 'mixed' : toggle.inputProps.checked }) });
}
